export default __webpack_public_path__ + "static/media/10pql.67954dad.png";